import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dropdown, MenuItem } from 'react-bootstrap';
import AccountDetailsBL from '../financial-stories/AccountDetailsNew/AccountDetailsBL';
import AddPersonComponent from './AddPersonComponent';
import AddCompanyComponent from './AddCompanyComponent';
import MoveMoneyPayeeStore from '../../stores/MoveMoneyPayeeStore';
import MoveMoneyStore from '../../stores/MoveMoneyStore';
import AccountsStore from '../../stores/AccountsStore';
import AppStore from '../../stores/AppStore';
import AppActions from '../../actions/AppActions';
import StepHeader from '../../includes/StepHeader';
import { processSessionCOPCheck } from '../../utils/COPUtils';
import { sayLandingMessage } from '../../actions/AccessibilityActionCreator';
import { get, map } from 'lodash';
import { COP } from 'payments-lib';
import { copCheckTriggeredHandler } from '../../utils/COPUtils';
import MoveMoneyPayeeActionCreator from '../../actions/MoveMoneyPayeeActionCreator';
import { GenericRadio } from 'web-ui-components/lib/data/capture';
import { GroupFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { VisuallyHiddenBody } from 'web-ui-components/lib/typography/body';
import StringConstant from '../../constants/StringConstants';
import { StepUpWrapper } from '../session';
import SessionStore from '../../stores/SessionStore';
import SessionActionCreator from '../../actions/SessionActionCreator';

const personItem = [{ id: 'person', labelText: 'Pay a person' }];
const businessItem = [{ id: 'business', labelText: 'Pay a business' }];
class AddPayeeOrCompanyMainPage extends Component {
  constructor(props) {
    super(props);
    this.buildCopPayeePayload = this.buildCopPayeePayload.bind(this);
    this.personOrCompanySelected = this.personOrCompanySelected.bind(this);
    this.goBackToMoveMoney = this.goBackToMoveMoney.bind(this);
    this.getPageToDisplay = this.getPageToDisplay.bind(this);
    this.goToMoveMoneyPage = this.goToMoveMoneyPage.bind(this);
    this.showHeader = this.showHeader.bind(this);
    this.goToManagePayees = this.goToManagePayees.bind(this);
    this.displayAccountDropDown = this.displayAccountDropDown.bind(this);
    this.showInlineError = this.showInlineError.bind(this);
    this.showCopComponent = this.showCopComponent.bind(this);
    this.handleCopResult = this.handleCopResult.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.setNickNameStatus = this.setNickNameStatus.bind(this);
    this.keyFieldsChanged = this.keyFieldsChanged.bind(this);
    this.onErrorModalClose = this.onErrorModalClose.bind(this);
    const { isSMEUser } = this.props;
    this.state = {
      isAddingBusinessPayeeManually: false,
      isPerson: true,
      defaultState: isSMEUser,
      showHeader: true,
      checkSelectedAccout: true,
      setAccount: 'Select an account',
      setBalance: null,
      accntSelection: false,
      callCOP: false,
      payeeDetails: {},
      displayLoader: false,
      isEditCOP: false,
      selectedPayee: MoveMoneyStore.getSelectedPayee(),
      isAddCompanyManual: false,
      isAddCompanyFromCOP: false,
      isEditCompanyFromCOP: false,
      radioStatus: '',
      buttonsVisible: true,
      isUpdateDisabled: true,
      tryCount: 1,
      nickNameEnable: false,
    };
  }

  componentWillMount() {
    const selectedAccount = MoveMoneyStore.getSelectedAccount();
    const singleAccount = this.props.filterAccountList();
    if (selectedAccount.id === undefined && singleAccount.length > 1) {
      this.setState({ checkSelectedAccout: false });
    } else if (this.props.filterAccountList().length === 1) {
      let acc = AccountsStore.getDefaultAccountForBeneficiaryCreation();
      if (acc != null) {
        this.setState({ accntSelection: true });
        MoveMoneyPayeeStore.setDefaultAccount(acc); // used for setting default account for ben creation
      }
      //  MoveMoneyPayeeStore.setDefaultAccount(singleAccount[0]);
    }
    if (selectedAccount.id !== undefined) {
      this.setState({ accntSelection: true });
    }
    window.scrollTo(0, 0);
  }

  componentDidMount() {
    sayLandingMessage(this.props.content.addPayeeContent);
  }

  componentWillUnmount() {
    SessionActionCreator.clearStepUpSession();
  }

  onAccountSelect(account) {
    if (account !== null) {
      this.setState({
        setAccount: account.displayName,
        setBalance: AccountDetailsBL.getAccountDisplayNumber(account),
        accntSelection: true,
      });
      MoveMoneyPayeeStore.setDefaultAccount(account);
      this.showInlineError('accntErr', 'dropdown-custom-menu', false);
    }
  }

  onErrorModalClose() {
    this.setState({
      displayLoader: false,
    });
  }

  setNickNameStatus(isNicknameEnable) {
    this.setState({ nickNameEnable: isNicknameEnable });
  }
  keyFieldsChanged() {
    this.setState({ tryCount: 1 });
  }
  getPageToDisplay() {
    const { isFromManagePayee, isSMEUser, session, envConfig, user } =
      this.props;
    const { isAddingBusinessPayeeManually, tryCount } = this.state;
    let content = '';
    if (this.state.defaultState) {
      content = (
        <div className="c-radio">
          {this.state.isPerson && (
            <AddPersonComponent
              setNickNameStatus={this.setNickNameStatus}
              content={this.props.content}
              goBackToMoveMoney={this.goBackToMoveMoney}
              comingFromCompanySearch={false}
              goToMoveMoneyPage={this.goToMoveMoneyPage}
              goToManagePayees={this.goToManagePayees}
              showHeader={this.showHeader}
              accntSelection={this.state.accntSelection}
              showInlineError={this.showInlineError}
              showCopComponent={this.showCopComponent}
              isFromManagePayee={isFromManagePayee}
              isSMEUser={isSMEUser}
              session={session}
              envConfig={envConfig}
              user={user}
              displayLoader={this.state.displayLoader}
              isEditCOP={this.state.isEditCOP}
              selectedPayee={this.state.selectedPayee}
              keyFieldsChanged={this.keyFieldsChanged}
              onErrorModalClose={this.onErrorModalClose}
            />
          )}
          {!this.state.isPerson && (
            <AddCompanyComponent
              setNickNameStatus={this.setNickNameStatus}
              addPayeeManuallyFlag={isAddingBusinessPayeeManually}
              updateIsEditCompanyFromCOP={() => {
                this.setState({
                  isEditCompanyFromCOP: false,
                  isAddCompanyFromCOP: false,
                });
              }}
              content={this.props.content}
              goBackToMoveMoney={this.goBackToMoveMoney}
              goToMoveMoneyPage={this.goToMoveMoneyPage}
              goToManagePayees={this.goToManagePayees}
              showHeader={this.showHeader}
              accntSelection={this.state.accntSelection}
              showInlineError={this.showInlineError}
              showCopComponent={this.showCopComponent}
              displayLoader={this.state.displayLoader}
              isAddCompanyFromCOP={this.state.isAddCompanyFromCOP}
              isEditCompanyFromCOP={this.state.isEditCompanyFromCOP}
              tryCount={tryCount}
              keyFieldsChanged={this.keyFieldsChanged}
              onErrorModalClose={this.onErrorModalClose}
            />
          )}
        </div>
      );
    }

    if (!isSMEUser && SessionStore.isStepUpMode()) {
      return (
        <StepUpWrapper
          content={this.props.content}
          handleSuccess={() => {
            this.createNewBeneficiary(
              MoveMoneyPayeeStore.getUnauthorisedBeneficiaryDetails()
            );
          }}
          handleCancel={this.props.goBackToMoveMoney}
        />
      );
    }

    if (this.state.callCOP) {
      const {
        payeeDetails: { account_number, name, reference, sort_code },
        isPerson,
        tryCount,
      } = this.state;
      const sessionCOPChecks = AppStore.getSessionCOPChecks();
      const cop = {
        accountName: name,
        accountNumber: account_number,
        sortCode: sort_code,
        accountType: isPerson ? 'Personal' : 'Business',
        reference: reference,
        beneficiaryId: '',
        customerId: user.id,
        customerType: 'retail',
        page: 'MakeMatch',
        tryCount: tryCount,
      };
      content = (
        <COP
          copCheckTriggered={copCheckTriggeredHandler}
          envConfig={envConfig}
          session={session}
          user={user}
          isPayeeSaved={this.state.nickNameEnable}
          cop={cop}
          handleCancel={this.props.goBackToMoveMoney}
          handleComplete={(copResult) => {
            this.handleCopResult(copResult, cop);
          }}
          handleEdit={this.handleEdit}
          sessionCOPChecks={sessionCOPChecks}
        />
      );
    }
    return content;
  }

  companySelected() {
    this.setState({ personOrCompany: false });
  }

  displayAccountDropDown() {
    const dropDown = [];
    const accountList = AccountsStore.getAccounts();
    map(accountList, (account, index) => {
      const accountNumber = AccountDetailsBL.getAccountDisplayNumber(account);
      if (
        account.actionsAvailable['/account/payments/uk/default/out'] === true
      ) {
        const accountDropDown = (
          <MenuItem
            eventKey={index.toString()}
            onSelect={this.onAccountSelect.bind(this, account)}
          >
            <span className="account-name">{account.displayName}</span>
            <span className="account-number">
              <span className="u-visually-hidden off-screen">
                Account Sort Code and Account Number{' '}
              </span>
              {accountNumber}
            </span>
          </MenuItem>
        );
        dropDown.push(accountDropDown);
      }
    });
    return dropDown;
  }

  goBackToMoveMoney() {
    this.props.goBackToMoveMoney();
  }

  goToManagePayees() {
    this.props.goToManagePayees();
  }

  goToMoveMoneyPage(props) {
    this.props.goToMoveMoneyPage(props);
  }

  personOrCompanySelected() {
    MoveMoneyPayeeStore.resetStore();
    this.setState({ defaultState: true });
    if (this.state.radioStatus === 'person') {
      this.setState({ isPerson: true, buttonsVisible: false });
    } else {
      this.setState({ isPerson: false, buttonsVisible: false });
    }
  }

  showHeader(val) {
    this.setState({ showHeader: val });
  }

  showInlineError(parent, name, isShowError) {
    if (parent == undefined) return;
    if (isShowError) {
      this.refs[parent].className += ' c-field--error';
      this.refs[name].innerHTML =
        'Choose an account to link this payee to then try again.';
    } else {
      this.refs[parent].className = 'c-field';
      this.refs[name].innerHTML = '';
    }
  }

  showCopComponent(formData, comingFromCompanySearch) {
    this.setState({
      callCOP: true,
      defaultState: false,
      payeeDetails: formData,
      isAddCompanyManual: comingFromCompanySearch,
    });
  }

  buildCopPayeePayload(copCheckResult, isPerson, name) {
    if (copCheckResult) {
      const {
        payeeName,
        payeeType,
        result: {
          cop_matching_outcome,
          matching_outcome,
          cop_reason_code,
          reason_code_description,
        } = {},
      } = copCheckResult;

      const matchingOutcome =
        cop_reason_code !== StringConstant.ERR1 &&
        cop_reason_code !== StringConstant.ERR2
          ? cop_matching_outcome
          : null;

      return {
        cop_account_name: payeeName,
        cop_account_type: payeeType,
        confirmation_of_payee: {
          cop_matching_outcome: matchingOutcome,
          cop_reason_code,
          reason_code_description,
          matching_outcome,
        },
      };
    } else {
      return {
        cop_account_name: name,
        cop_account_type: isPerson ? 'Personal' : 'Business',
        confirmation_of_payee: {
          cop_matching_outcome: null,
          cop_reason_code: null,
          matching_outcome: null,
          reason_code_description: 'CoP Service Unavailable',
        },
      };
    }
  }

  handleCopResult(result, scanDetails) {
    const {
      isPerson,
      payeeDetails: { name },
    } = this.state;

    const wasASuccessfulMatch = get(result, 'cop_matching_outcome');
    const sessionCOPChecks = AppStore.getSessionCOPChecks();
    if (wasASuccessfulMatch) {
      const newSessionCOPChecks = processSessionCOPCheck(
        scanDetails,
        true,
        sessionCOPChecks
      );
      AppActions.setSessionCOPChecks(newSessionCOPChecks);
    }

    const payeePayload = this.buildCopPayeePayload(result, isPerson, name);
    this.createNewBeneficiary(payeePayload);
  }

  createNewBeneficiary = (payeePayload) => {
    const { isPerson, isAddCompanyManual } = this.state;

    const isCompanyPayee = !isPerson && !isAddCompanyManual;

    if (isCompanyPayee) {
      this.setState({
        callCOP: false,
        defaultState: true,
        displayLoader: true,
        isPerson: false,
        isAddCompanyFromCOP: true,
      });
      MoveMoneyPayeeActionCreator.addCompanyPayee(payeePayload);
    } else {
      this.setState({
        callCOP: false,
        defaultState: true,
        displayLoader: true,
        isPerson: true,
      });
      MoveMoneyPayeeActionCreator.addPayee(payeePayload);
    }
  };

  handleEdit() {
    const { isAddCompanyManual, isPerson } = this.state;

    const isManualBusinessPayeeAdd = !isPerson && isAddCompanyManual;
    const isBillerPayeeAdd = !isPerson;

    if (isManualBusinessPayeeAdd) {
      this.setState((prevState) => ({
        callCOP: false,
        defaultState: true,
        isAddingBusinessPayeeManually: true,
        isEditCompanyFromCOP: true,
        tryCount: prevState.tryCount + 1,
      }));
    } else if (isBillerPayeeAdd) {
      this.setState((prevState) => ({
        callCOP: false,
        defaultState: true,
        isPerson: false,
        isEditCompanyFromCOP: true,
        displayLoader: false,
        isAddCompanyFromCOP: false,
        tryCount: prevState.tryCount + 1,
      }));
    } else {
      this.setState((prevState) => ({
        isEditCOP: true,
        callCOP: false,
        isPerson: true,
        defaultState: true,
        showHeader: true,
        tryCount: prevState.tryCount + 1,
      }));
    }
  }
  renderHeader() {
    const { isSMEUser } = this.props;
    const { buttonsVisible } = this.state;
    let renderContent = (
      <div>
        <StepHeader
          showheaderCrumbs="true"
          onClick={this.goBackToMoveMoney}
          headerCrumbsMessage={this.props.content.back}
          headerTitle={this.props.content.addPayeeContent}
        />
        {!this.state.checkSelectedAccout && (
          <div className="c-field" ref="accntErr">
            <label
              id="chooseLabel"
              className="c-field__label c-field__label--block"
              htmlFor="dropdown-custom-menu"
            >
              Choose one of your accounts to link this payee to
              <div className="c-field__instructions">
                You'll still be able to move money to this payee from your other
                accounts.
              </div>
            </label>
            <div className="c-field__controls">
              <div className="btn-toolbar">
                <Dropdown
                  id="dropdown-custom-menu"
                  name="dropdown-custom-menu"
                  className="custom-dropdown"
                  aria-invalid="false"
                  aria-required="true"
                  aria-live="accountError"
                  data-parent="accntErr"
                >
                  <Dropdown.Toggle
                    noCaret
                    aria-labelledby="chooseLabel selectedValue"
                    className="custom-dropdown__btn"
                  >
                    <span
                      id="selectedValue"
                      className="btn--title btn--title--multiline"
                    >
                      <span>{this.state.setAccount}</span>
                      {this.state.setBalance && (
                        <span>{this.state.setBalance}</span>
                      )}
                    </span>
                    <span className="symbol">
                      <svg
                        width="32"
                        height="61"
                        viewBox="0 0 32 32"
                        role="img"
                      >
                        <path d="M19.55 12.602l1.884 1.833-5.717 5.565-5.717-5.565 1.883-1.833 3.833 3.731z" />
                      </svg>
                    </span>
                  </Dropdown.Toggle>
                  <Dropdown.Menu>{this.displayAccountDropDown()}</Dropdown.Menu>
                </Dropdown>
              </div>
              <div
                role="alert"
                id="accountError"
                className="c-field__message"
                ref="dropdown-custom-menu"
              />
            </div>
          </div>
        )}
        {!isSMEUser && (
          <div className="c-field" ref="startDateErr">
            <label
              className="c-field__label c-field__label--block"
              htmlFor="dtStart"
              id="subHeader"
            >
              {this.props.content.subHeader}
            </label>
            {buttonsVisible && (
              <div className="c-field__controls">
                {/* Radio button starts here*/}
                <GroupFieldWrapper
                  titleContent={
                    <VisuallyHiddenBody>
                      {this.props.content.subHeader}
                    </VisuallyHiddenBody>
                  }
                >
                  <div className="c-radio">
                    <GenericRadio.StackedSet
                      groupName="radio-group-person"
                      items={personItem}
                      onChange={(radioStatus) => this.setState({ radioStatus })}
                      selectedId={this.state.radioStatus}
                    />
                    <GenericRadio.StackedSet
                      groupName="radio-group-person"
                      items={businessItem}
                      onChange={(radioStatus) => this.setState({ radioStatus })}
                      selectedId={this.state.radioStatus}
                    />
                  </div>
                </GroupFieldWrapper>
                {/* radio button ends here*/}
                <div className="add-edit-payee__form__options">
                  <button
                    type="button"
                    className="c-btn c-btn--secondary"
                    onClick={this.goBackToMoveMoney}
                  >
                    Back
                  </button>
                  <button
                    data-test-id="add-payee-continue-button"
                    type="button"
                    className="c-btn c-btn--default"
                    onClick={this.personOrCompanySelected}
                    disabled={
                      this.state.radioStatus && this.state.accntSelection
                        ? false
                        : !this.state.radioStatus || this.state.isUpdateDisabled
                    }
                  >
                    Continue
                  </button>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );

    if (!this.state.showHeader) renderContent = '';

    return renderContent;
  }

  render() {
    let renderContent;

    renderContent = (
      <div
        className="container add-edit-payee"
        id="site-main"
        role="main"
        tabIndex="-1"
      >
        <div className="row">
          <div className="col-xl1-18 col-lg1-18 col-md1-18">
            {/* <span id="accessH1ID" tabIndex="0" className="u-visually-hidden off-screen" ref="accessH1ID">You are on {this.props.content.addPayeeContent} </span> */}
            {this.renderHeader()}
            {this.getPageToDisplay()}
          </div>
        </div>
      </div>
    );

    return <div>{renderContent}</div>;
  }
}

AddPayeeOrCompanyMainPage.propTypes = {
  content: PropTypes.object,
  goToManagePayees: PropTypes.func,
  goToMoveMoneyPage: PropTypes.func,
  goBackToMoveMoney: PropTypes.func,
  onAccountSelect: PropTypes.func,
  isSMEUser: PropTypes.bool.isRequired,
  isFromManagePayee: PropTypes.bool,
};
AddPayeeOrCompanyMainPage.defaultProps = {
  content: {},
  isFromManagePayee: false,
};
export default AddPayeeOrCompanyMainPage;
